<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 * 
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *            佛祖保佑     永不宕机     永无BUG
 * 
 *        佛曰:  
 *                写字楼里写字间，写字间里程序员；  
 *                程序人员写程序，又拿程序换酒钱。  
 *                酒醒只在网上坐，酒醉还来网下眠；  
 *                酒醉酒醒日复日，网上网下年复年。  
 *                但愿老死电脑间，不愿鞠躬老板前；  
 *                奔驰宝马贵者趣，公交自行程序员。  
 *                别人笑我忒疯癫，我笑自己命太贱；  
 *                不见满街漂亮妹，哪个归得程序员？
 * 
 * @Author: ZP
 * @Date: 2023-10-22 09:21:47
 * @FilePath: \project\Disassembly_mobile\src\views\Bidding\components\cashDeposit.vue
 * @LastEditors: zp
 * @LastEditTime: 2024-03-12 16:00:43
 -->

<template>
    <div>
        <h2>信息提交</h2>
        <van-form class="popup-form" @submit="onSubmit">
            <van-field label="应付金额: " v-model="bankInfo.earnest_money" readonly />
            <van-field label="开户名称: " v-if="valObj.is_cxd_order != 1" v-model="bankInfo.bank_name" readonly />
            <van-field label="开户银行：" v-if="valObj.is_cxd_order != 1" v-model="bankInfo.bank" readonly />
            <van-field label="银行账号：" v-if="valObj.is_cxd_order != 1" v-model="bankInfo.bank_number" readonly />
            <van-field name="uploader"  v-if="valObj.is_cxd_order != 1" label="转账记录：" :rules="[{ required: true, message: '上传照片！' }]">
                 <template #input>
                    <UploadImg
                        ref="business_license"
                        :images="business_license"
                        :maxCount="1"
                    ></UploadImg>
                    </template>
            </van-field>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import UploadImg from '@/components/UploadImg'
import { micro_post } from "../../../Http/api.js";
    export default {
        components: {
            UploadImg,
        },
        data() {
            return {
                fileList1:[],
                business_license: [],
                pic:'123',
                bankInfo:{},
                valObj:{},
            }
        },
        methods: {
            onSubmit() {
                let obj = {
                    shopId:this.$route.query.shopId,
                    type:this.$route.query.type,
                    act_id:this.valObj.id,
                    pay_image:this.valObj.is_cxd_order == 1?'':this.$refs.business_license.imagesUrlList[0]
                }
                 const data = {
                    url: "index.php/BidManagement/bidSignOrder",
                    params:obj,
                    success: (res) => {
                        this.$toast.fail(res.msg)
                        this.$emit('application')
                    },
                   
                };
                micro_post(data,this);
            },
            getInfo(val){
                this.valObj = val
                if(val.is_cxd_order != 1){

                    this.$refs.business_license.imagesUrlList = []
                    this.$refs.business_license.images = []
                }
                const data = {
                    url: "index.php/BidManagement/bidSignOrderDetail",
                    params: { id:val.id },
                    success: (res) => {
               
                        this.bankInfo = res.data
                    },
                   
                };
                micro_post(data,this);
            },
            afterDelete(file){

            },
            uploadershang(file){

            }
        },
    }
</script>

<style lang="scss" scoped>
h2{
    text-align: center;
}
</style>